import { date } from 'quasar';

export const formatDate = (dateString: string): string => {
  const dateObject = new Date(dateString);
  return dateObject.toLocaleString();
  /*
        const formattedString = date.formatDate(
          timeStamp,
          'YYYY-MM-DD HH:mm:ss'
        );
        */
};
